import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SeatingRule, SeatingRuleInput } from '@td/shared';
import { get, post, patch, del } from '../lib/api';

const KEY = ['seating-rules'];

export function useSeatingRules() {
  return useQuery({ queryKey: KEY, queryFn: () => get<SeatingRule[]>('/seating-rules') });
}

export function useCreateRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SeatingRuleInput) => post<SeatingRule>('/seating-rules', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...input }: Partial<SeatingRuleInput> & { id: string }) =>
      patch<SeatingRule>(`/seating-rules/${id}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => del<void>(`/seating-rules/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
